import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject } from '@angular/core';
import { MemberModelService } from '../../services/member-model.service';
var ReferenceNumberComponent = /** @class */ (function () {
    function ReferenceNumberComponent(memberModel) {
        this.memberModel = memberModel;
    }
    ReferenceNumberComponent = __decorate([
        Component({
            selector: 'referenceNumber',
            templateUrl: 'app/components/reference-number/reference-number.html'
        }),
        __param(0, Inject(MemberModelService)),
        __metadata("design:paramtypes", [Object])
    ], ReferenceNumberComponent);
    return ReferenceNumberComponent;
}());
export { ReferenceNumberComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVmZXJlbmNlLW51bWJlci5jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi93b3JrcGxhY2VMaXZpbmdTZXJ2aWNlcy9zcmMvYXBwL2NvbXBvbmVudHMvcmVmZXJlbmNlLW51bWJlci9yZWZlcmVuY2UtbnVtYmVyLmNvbXBvbmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxFQUFDLFNBQVMsRUFBRSxNQUFNLEVBQUMsTUFBTSxlQUFlLENBQUE7QUFFL0MsT0FBTyxFQUFDLGtCQUFrQixFQUFDLE1BQU0scUNBQXFDLENBQUM7QUFNdkU7SUFFRSxrQ0FBc0QsV0FBVztRQUFYLGdCQUFXLEdBQVgsV0FBVyxDQUFBO0lBQUcsQ0FBQztJQUYxRCx3QkFBd0I7UUFKcEMsU0FBUyxDQUFDO1lBQ1QsUUFBUSxFQUFFLGlCQUFpQjtZQUMzQixXQUFXLEVBQUUsdURBQXVEO1NBQ3JFLENBQUM7UUFHb0IsV0FBQSxNQUFNLENBQUMsa0JBQWtCLENBQUMsQ0FBQTs7T0FGbkMsd0JBQXdCLENBR3BDO0lBQUQsK0JBQUM7Q0FBQSxBQUhELElBR0M7U0FIWSx3QkFBd0IifQ==